import { render, staticRenderFns } from "./About.vue?vue&type=template&id=2c11fd19&lang=pug&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c11fd19')) {
      api.createRecord('2c11fd19', component.options)
    } else {
      api.reload('2c11fd19', component.options)
    }
    module.hot.accept("./About.vue?vue&type=template&id=2c11fd19&lang=pug&", function () {
      api.rerender('2c11fd19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/About.vue"
export default component.exports